import { styled, Typography } from '@mui/material';
import { ContentIsland, ContentIslandProps } from './ContentIsland';
import { LocalizedError } from '../List/ErrorListItem';

export type ErrorContentIslandSlotProps = { error: Error };
export type ErrorContentIslandProps = ContentIslandProps & ErrorContentIslandSlotProps;

const ErrorContainer = styled('div', {
  name: 'ErrorContentIsland',
  slot: 'container',
})(({ theme }) => ({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3, 4),
}));

export function ErrorContentIsland({ children, error, ...props }: ErrorContentIslandProps) {
  return (
    <ContentIsland {...props}>
      <ErrorContainer>
        <Typography variant="body1" color="error.main">
          <LocalizedError error={error} />
        </Typography>
      </ErrorContainer>
      {children}
    </ContentIsland>
  );
}
